/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsObjectsIntegrationType } from './WebApiIntegrationsObjectsIntegrationType';
import {
    WebApiIntegrationsObjectsIntegrationTypeFromJSON,
    WebApiIntegrationsObjectsIntegrationTypeFromJSONTyped,
    WebApiIntegrationsObjectsIntegrationTypeToJSON,
} from './WebApiIntegrationsObjectsIntegrationType';

/**
 * One membership year on the public site payments page.
 * @export
 * @interface WebApiPublicSiteDtoPublicPaymentYearDto
 */
export interface WebApiPublicSiteDtoPublicPaymentYearDto {
    /**
     * The membership year.
     * @type {number}
     * @memberof WebApiPublicSiteDtoPublicPaymentYearDto
     */
    year?: number;
    /**
     * Paid by any means (manual, Ping, Fortnox, Spiris), refunds excluded.
     * @type {boolean}
     * @memberof WebApiPublicSiteDtoPublicPaymentYearDto
     */
    isPaid?: boolean;
    /**
     * Paid amount, or the outstanding amount when unpaid (0 when unknown).
     * @type {number}
     * @memberof WebApiPublicSiteDtoPublicPaymentYearDto
     */
    amount?: number;
    /**
     * 
     * @type {WebApiIntegrationsObjectsIntegrationType}
     * @memberof WebApiPublicSiteDtoPublicPaymentYearDto
     */
    source?: WebApiIntegrationsObjectsIntegrationType;
    /**
     * Checkout link for an outstanding Ping Payments link. Only set when the company shows pay links and the member pays for the household.
     * @type {string}
     * @memberof WebApiPublicSiteDtoPublicPaymentYearDto
     */
    payUrl?: string | null;
    /**
     * True when the year was paid through a Ping Payments link, whose receipt the member can download
     *             (GetMemberPaymentReceipt). Ping's own receipt links only work for an hour, so no link is handed out here.
     * @type {boolean}
     * @memberof WebApiPublicSiteDtoPublicPaymentYearDto
     */
    hasReceipt?: boolean;
    /**
     * Due date of an outstanding invoice/link.
     * @type {Date}
     * @memberof WebApiPublicSiteDtoPublicPaymentYearDto
     */
    dueDate?: Date | null;
}

/**
 * Check if a given object implements the WebApiPublicSiteDtoPublicPaymentYearDto interface.
 */
export function instanceOfWebApiPublicSiteDtoPublicPaymentYearDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPublicSiteDtoPublicPaymentYearDtoFromJSON(json: any): WebApiPublicSiteDtoPublicPaymentYearDto {
    return WebApiPublicSiteDtoPublicPaymentYearDtoFromJSONTyped(json, false);
}

export function WebApiPublicSiteDtoPublicPaymentYearDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPublicSiteDtoPublicPaymentYearDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'year': !exists(json, 'year') ? undefined : json['year'],
        'isPaid': !exists(json, 'isPaid') ? undefined : json['isPaid'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'source': !exists(json, 'source') ? undefined : WebApiIntegrationsObjectsIntegrationTypeFromJSON(json['source']),
        'payUrl': !exists(json, 'payUrl') ? undefined : json['payUrl'],
        'hasReceipt': !exists(json, 'hasReceipt') ? undefined : json['hasReceipt'],
        'dueDate': !exists(json, 'dueDate') ? undefined : (json['dueDate'] === null ? null : new Date(json['dueDate'])),
    };
}

export function WebApiPublicSiteDtoPublicPaymentYearDtoToJSON(value?: WebApiPublicSiteDtoPublicPaymentYearDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'year': value.year,
        'isPaid': value.isPaid,
        'amount': value.amount,
        'source': WebApiIntegrationsObjectsIntegrationTypeToJSON(value.source),
        'payUrl': value.payUrl,
        'hasReceipt': value.hasReceipt,
        'dueDate': value.dueDate === undefined ? undefined : (value.dueDate === null ? null : value.dueDate.toISOString()),
    };
}

